import { Box, Button, Stack } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import MyCompetencies from "./components/competencies";
import Trainings from "./components/trainings";
import { buttonStyles } from "services/utils";

export default function Competencies() {
  const [view, setView] = useState(0); // 0 = My Competencies, 1 = Trainings
  const { t, i18n } = useTranslation();

  return (
    <Box>
      {/* Buttons to switch views */}
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 1 }}>
        <Button
          sx={{ ...buttonStyles(view === 0), width: { xs: "100%", sm: "auto" } }}
          variant={view === 0 ? "contained" : "outlined"}
          onClick={() => setView(0)}
        >
          {t("uroutes.competencies")}
        </Button>
        <Button
          sx={{ ...buttonStyles(view === 1), width: { xs: "100%", sm: "auto" } }}
          variant={view === 1 ? "contained" : "outlined"}
          onClick={() => setView(1)}
        >
          {t("uroutes.trainings")}
        </Button>
      </Stack>

      {/* Render chosen view */}
      {view === 0 ? <MyCompetencies /> : <Trainings />}
    </Box>
  );
}
